/* eslint-disable react/jsx-curly-newline */
/* eslint-disable arrow-body-style */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React from 'react';
import { useFormik } from 'formik';

import { CommonCurrencyInput, CommonInput, DatePicker, OutlinedButton, RegularButton } from 'pg-ui-library';
import { IBenefitType } from 'src/interfaces';
import { useTranslation } from 'react-i18next';
import { PriceFormType } from 'src/services/benefits.service';
import { useNavigate } from 'react-router-dom';
import {
  AccordeonContent,
  FixedPriceContent,
  FixedPriceHeader,
  FixedPriceLine,
  HeaderContent,
  HeaderInfo,
  HorizontalLine,
} from './styles';

import { useBenefitDeletePrice } from '../../queries/benefit-delete-price.mutation';
import { usePatchBenefitAgeLines } from '../../mutations/patch-benefit-age-lines.mutation';

export const BenefitAgeLines: React.FC<{
  selectedBenefitType: IBenefitType | undefined;
}> = ({ selectedBenefitType }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const patchAgePriceMutation = usePatchBenefitAgeLines();

  const removePriceMutation = useBenefitDeletePrice();

  const isLoading = patchAgePriceMutation.isLoading || removePriceMutation.isLoading;

  const submitTableBenefit = (values: PriceFormType) => {
    return patchAgePriceMutation.mutateAsync(values);
  };

  const formik = useFormik<any>({
    initialValues: {
      type: selectedBenefitType?.type || '',
      versionId: selectedBenefitType?.versionId,
      agePriceLines: selectedBenefitType?.agePriceLines || [],
    },
    onSubmit: async values => {
      try {
        await submitTableBenefit({ ...values });
      } catch (error) {
        // do not redirect
      }
    },
    enableReinitialize: true,
  });

  const addAgePriceLine = () => {
    const newLine = {
      versionId: selectedBenefitType?.versionId,
      ageStart: 0,
      ageEnd: 0,
      EE: 0,
      EE_SMOKER_PREMIUM: 0,
      EC: 0,
      ES: 0,
      EC_SMOKER_PREMIUM: 0,
      EFAM_SMOKER_PREMIUM: 0,
      ES_SMOKER_PREMIUM: 0,
      FAM: 0,
    };

    formik.setFieldValue('agePriceLines', [...formik.values.agePriceLines, newLine]);
  };

  const deletePrice = async () => {
    try {
      await removePriceMutation.mutateAsync({
        id: formik.values.id as string,
        type: 'table',
      });
      navigate(-1 as any);
    } catch (error) {
      // do not redirect
    }
  };

  return (
    <AccordeonContent>
      <HeaderInfo>
        <div>
          <RegularButton onClick={() => formik.handleSubmit()} disabled={isLoading} type="submit">
            {formik.values.id ? t('global.form.update') : t('global.form.save')}
          </RegularButton>
          {formik.values.id && (
            <OutlinedButton onClick={deletePrice} disabled={isLoading}>
              {t('global.form.delete')}
            </OutlinedButton>
          )}
        </div>
      </HeaderInfo>
      <HeaderContent>
        <CommonInput disabled label="Type" id="benefitType" name="benefitType" value={formik.values.type} />
      </HeaderContent>

      <FixedPriceHeader>
        <p>{t('benefits.edit.agePrice.agePriceLine')}</p>
        <HorizontalLine />
        <RegularButton onClick={() => addAgePriceLine()}>{t('global.form.add')}</RegularButton>
      </FixedPriceHeader>

      <FixedPriceContent>
        {formik.values.agePriceLines.map(
          (
            val: {
              ageStart: string | number | readonly string[] | undefined;
              ageEnd: string | number | readonly string[] | undefined;
              EE: string | number | readonly string[] | undefined;
              EE_SMOKER_PREMIUM: string | number | readonly string[] | undefined;
              EC: string | number | readonly string[] | undefined;
              ES: string | number | readonly string[] | undefined;
              EFAM_SMOKER_PREMIUM: string | number | readonly string[] | undefined;
              EC_SMOKER_PREMIUM: string | number | readonly string[] | undefined;
              ES_SMOKER_PREMIUM: string | number | readonly string[] | undefined;
              FAM: string | number | readonly string[] | undefined;
            },
            index: React.Key | null | undefined
          ) => (
            <FixedPriceLine key={index}>
              <CommonCurrencyInput
                id="ageStart"
                label={index === 0 ? 'Age Start' : ''}
                name="ageStart"
                placeholder="Please enter a number"
                prefix=""
                max={100}
                maxLength={3}
                allowDecimals={false}
                allowNegativeValue={false}
                value={val.ageStart}
                groupSeparator=","
                decimalSeparator="."
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].ageStart`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].ageStart`, v);
                  }
                }}
              />
              <CommonCurrencyInput
                id="ageEnd"
                label={index === 0 ? 'Age End' : ''}
                name="ageEnd"
                placeholder="Please enter a number"
                prefix=""
                allowDecimals={false}
                allowNegativeValue={false}
                max={100}
                maxLength={3}
                value={val.ageEnd}
                groupSeparator=","
                decimalSeparator="."
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].ageEnd`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].ageEnd`, v);
                  }
                }}
              />
              <CommonCurrencyInput
                id="EE"
                label={index === 0 ? 'EE' : ''}
                name="EE"
                placeholder="Please enter a number"
                prefix="$"
                decimalsLimit={7}
                groupSeparator=","
                decimalSeparator="."
                allowNegativeValue={false}
                value={val.EE}
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].EE`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].EE`, v);
                  }
                }}
              />
              <CommonCurrencyInput
                id="EE_SMOKER_PREMIUM"
                label={index === 0 ? 'EE Smoker Premium' : ''}
                name="EE_SMOKER_PREMIUM"
                placeholder="Please enter a number"
                prefix="$"
                decimalsLimit={7}
                allowNegativeValue={false}
                value={val.EE_SMOKER_PREMIUM}
                groupSeparator=","
                decimalSeparator="."
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].EE_SMOKER_PREMIUM`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].EE_SMOKER_PREMIUM`, v);
                  }
                }}
              />
              <CommonCurrencyInput
                id="EC"
                label={index === 0 ? 'EC' : ''}
                name="EC"
                placeholder="Please enter a number"
                prefix="$"
                decimalsLimit={7}
                allowNegativeValue={false}
                value={val.EC}
                groupSeparator=","
                decimalSeparator="."
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].EC`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].EC`, v);
                  }
                }}
              />
              <CommonCurrencyInput
                id="EC_SMOKER_PREMIUM"
                label={index === 0 ? 'EC Smoker Premium' : ''}
                name="EC_SMOKER_PREMIUM"
                placeholder="Please enter a number"
                prefix="$"
                decimalsLimit={7}
                allowNegativeValue={false}
                value={val.EC_SMOKER_PREMIUM}
                groupSeparator=","
                decimalSeparator="."
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].EC_SMOKER_PREMIUM`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].EC_SMOKER_PREMIUM`, v);
                  }
                }}
              />
              <CommonCurrencyInput
                id="ES"
                label={index === 0 ? 'ES' : ''}
                name="ES"
                placeholder="Please enter a number"
                prefix="$"
                decimalsLimit={7}
                allowNegativeValue={false}
                value={val.ES}
                groupSeparator=","
                decimalSeparator="."
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].ES`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].ES`, v);
                  }
                }}
              />
              <CommonCurrencyInput
                id="ES_SMOKER_PREMIUM"
                label={index === 0 ? 'ES Smoker Premium' : ''}
                name="ES_SMOKER_PREMIUM"
                placeholder="Please enter a number"
                prefix="$"
                decimalsLimit={7}
                allowNegativeValue={false}
                value={val.ES_SMOKER_PREMIUM}
                groupSeparator=","
                decimalSeparator="."
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].ES_SMOKER_PREMIUM`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].ES_SMOKER_PREMIUM`, v);
                  }
                }}
              />
              <CommonCurrencyInput
                id="FAM"
                label={index === 0 ? 'FAM' : ''}
                name="FAM"
                placeholder="Please enter a number"
                prefix="$"
                decimalsLimit={7}
                allowNegativeValue={false}
                value={val.FAM}
                groupSeparator=","
                decimalSeparator="."
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].FAM`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].FAM`, v);
                  }
                }}
              />
              <CommonCurrencyInput
                id="EFAM_SMOKER_PREMIUM"
                label={index === 0 ? 'EFAM Smoker Premium' : ''}
                name="EFAM_SMOKER_PREMIUM"
                placeholder="Please enter a number"
                prefix="$"
                decimalsLimit={7}
                allowNegativeValue={false}
                value={val.EFAM_SMOKER_PREMIUM}
                groupSeparator=","
                decimalSeparator="."
                onValueChange={v => {
                  if (Number.isNaN(v)) {
                    formik.setFieldValue(`agePriceLines[${index}].EFAM_SMOKER_PREMIUM`, 0);
                  } else {
                    formik.setFieldValue(`agePriceLines[${index}].EFAM_SMOKER_PREMIUM`, v);
                  }
                }}
              />
            </FixedPriceLine>
          )
        )}
      </FixedPriceContent>
    </AccordeonContent>
  );
};
